import styled from '@emotion/styled';
import { COLORS, FONT, MEDIA_QUERY, utils } from '../../../../styles/emotion';
import CloseIcon from '../../../SvgIcons/Close';

export const MobileHeader = styled.div`
  display: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    display: block;
  }
  border-bottom: 2px solid ${COLORS.ALTO};
  text-align: center;
  padding: 20px 0;
  font-size: ${FONT.FONT_SIZE_REGULAR};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  right: 20px;
  top: 14px;
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  color: ${COLORS.EMPEROR};
`;
export const ListBoxContainer = styled.div`
  cursor: pointer;
  margin-top: 4px;
  border: 2px solid ${COLORS.ALTO};
  border-radius: 4px;
  background-color: ${COLORS.WHITE};
  position: absolute;
  z-index: 20;
  max-height: 300px;
  overflow: auto;
  width: 100%;
  ${utils.defaultBoxShadow};

  ${MEDIA_QUERY.MOBILE_XS} {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    margin: 0;
    border: none;
    height: 100vh;
    max-height: none;
  }
`;

export const ListBox = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    padding: 12px 6px;
  }
`;

export const MobileCtaSection = styled.div`
  display: none;
  ${MEDIA_QUERY.MOBILE_XS} {
    display: block;
  }
  box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.1);
  border-top: 2px solid ${COLORS.ALTO};
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 12px 14px 20px;
  background-color: ${COLORS.WHITE};
`;
